import styled, { css } from "styled-components"

export const MainContainer = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: ${({ legendPosition }) =>
    legendPosition === "right" || legendPosition === "left" ? "" : "column"};
  justify-content: ${({ legendPosition }) =>
    legendPosition === "right" || legendPosition === "left" ? "center" : "space-evenly"};
`

// Progress bar part
export const ProgressBarContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  margin: 25px 0;
`

export const LegendContainer = styled.div`
  justify-content: center;
  overflow-x: hidden;
  display: flex;
  align-items: ${({ legendPosition }) =>
    legendPosition === "right" || legendPosition === "left" ? "" : "center"};
  height: ${({ legendPosition }) =>
    legendPosition === "right" || legendPosition === "left" ? "100%" : "40px"};
  width: ${({ legendPosition }) =>
    legendPosition === "right" || legendPosition === "left" ? "200px" : "100%"};
  flex-direction: ${({ legendPosition }) =>
    legendPosition === "right" || legendPosition === "left" ? "column" : ""};
  margin: ${({ legendPosition }) =>
    legendPosition === "right" || legendPosition === "left" ? "0 1rem" : ""};
`

export const Value = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  top: ${({ labelPosition, legendPosition, fontHeight }) =>
    fontHeight && (labelPosition === "top" || legendPosition === "top")
      ? fontHeight + 5 + "px"
      : fontHeight && (labelPosition === "bottom" || legendPosition === "bottom")
      ? "-" + (fontHeight + 5) + "px"
      : "0px"};
  display: flex;
  align-items: center;
  justify-content: ${({ index, checkLength }) =>
    index === 0 && checkLength ? "flex-start" : index === 1 && checkLength ? "flex-end" : "center"};
  color: ${props => (props.valueColor ? props.valueColor : "#000")};
  font-size: ${props => (props.valueSize ? props.valueSize + "rem" : "1rem")};
  font-weight: ${props => (props.valueWeight ? props.valueWeight : "normal")};
`

export const Span = styled.div`
  font-size: ${props => (props.valueSize ? props.valueSize / 1.5 + "rem" : "1rem")};
  color: ${props => (props.valueColor ? props.valueColor : "#000")};
  margin: 0.25rem 0 0 0.05rem;
`

export const Label = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  top: ${({ labelPosition, fontHeight }) =>
    fontHeight && labelPosition === "top"
      ? "-" + (fontHeight + 5) + "px"
      : fontHeight && labelPosition === "bottom"
      ? fontHeight + 5 + "px"
      : "0px"};
  display: flex;
  align-items: center;
  justify-content: ${({ index, checkLength }) =>
    index === 0 && checkLength ? "flex-start" : index === 1 && checkLength ? "flex-end" : "center"};
  color: ${props => (props.labelColor ? props.labelColor : "#000")};
  font-size: ${props => (props.labelSize ? props.labelSize : "1rem")};
  font-weight: ${props => (props.labelWeight ? props.labelWeight : "normal")};
`

export const Legend = styled.div`
  display: flex;
  align-items: center;
  margin: ${({ legendPosition }) =>
    legendPosition === "right" || legendPosition === "left" ? "0rem 1rem 0.25rem 0" : "0 1rem 0 0"};
`

export const Square = styled.div`
  width: 25px;
  height: 25px;
  background-color: ${props => (props.color ? props.color : "#000")};
  margin: 0 0.75rem 0 0;
`

export const LegendLabel = styled.div``

export const Bar = styled.div`
  width: ${props => (props.width !== undefined ? props.width + "%" : "100%")};
  background-color: ${props => (props.color ? props.color : "#000")};
  transition: 0.25s ease;
  border-radius: ${props => (props.radius >= 0 ? props.radius + "px" : "20px")};
  height: ${props => (props.height ? props.height + "px" : "20px")};
  position: relative;

  .tooltip {
    position: absolute;
    top: 0px;
    left: 25%;
    z-index: 510;
    background: #fff;
    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.3);
    padding: 6px 12px;
    border-radius: 4px;
    font-size: 15px;
    font-weight: 600;
    opacity: 0;
    pointer-events: none;
    transition: 0s;
    width: max-content;
  }

  &:hover .tooltip {
    opacity: 1;
    pointer-events: auto;
    transition: all 0.4s ease;
    top: 30px;
  }
`

// ++++++++++++++++++++++++ MULTI PROGRESS BAR ++++++++++++++++++++++++ //
export const MultiMainContainer = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
`

export const MultiContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin: 0.75rem 0;
`

export const MultiLabel = styled.div`
  width: 20%;
  max-width: 20%;
  /* text-align: center; */
  color: ${props => (props.labelColor ? props.labelColor : "#000")};
  font-size: ${props => (props.labelSize ? props.labelSize : "1rem")};
  font-weight: ${props => (props.labelWeight ? props.labelWeight : "normal")};
  display: flex;
  align-items: center;
  /* justify-content: center; */
  margin: 0 1rem 0 0;

  ${({ isMobile }) =>
    isMobile &&
    css`
      font-size: 1rem;
      width: 30%;
      max-width: 30%;
      word-break: break-all;
    `}
`

export const MultiValue = styled.div`
  display: flex;
  align-items: center;
  color: ${props => (props.valueColor ? props.valueColor : "#000")};
  font-size: ${props => (props.valueSize ? props.valueSize + "rem" : "1rem")};
  font-weight: ${props => (props.valueWeight ? props.valueWeight : "normal")};
  width: 15%;
  max-width: 15%;

  ${({ isMobile }) =>
    isMobile &&
    css`
      font-size: 1rem;
      width: 30%;
      max-width: 30%;
    `}
`

export const MultiProgressBarContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  width: 45%;

  ${({ isMobile }) =>
    isMobile &&
    css`
      width: 30%;
      max-width: 30%;
    `}
`
